import React, { useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { Box, Snackbar } from "@mui/material";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import axiosInstance from "../../../services/axiosInstance";

const PayPalCheckout = ({ amount }) => {
  const [cancelMessage, setCancelMessage] = useState("");
  const savePaymentData = async ({
    orderID,
    payerID,
    paymentDetails,
    amount,
    currency,
  }) => {
    return await axiosInstance.post(`${apiEndPointsConfig.savePayment}/save-payment`, {
      orderID,
      payerID,
      paymentDetails,
      amount,
      currency,
    });
  };
  return (
    <Box sx={{ width: "100%" }}>
      <PayPalScriptProvider
        options={{
          "client-id":
            "AT0AXMRAdJs6ravisTft7aUVRdQtxFmZ81B-LXHPfnjnc4DUJPTLb1dy1cbp7WTJ9GQsT-m7I87qXH_s",
          currency: "USD",
        }}
      >
        <PayPalButtons
          style={{ layout: "vertical" }}
          forceReRender={[amount, "USD"]}
          createOrder={(data, actions) => {
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    currency: "USD",
                    value: amount,
                  },
                },
              ],
            });
          }}
          onApprove={(data, actions) => {
            return actions.order.capture().then(async (details) => {
              alert(
                "Transaction completed by " + details.payer.name.given_name
              );
              console.log("Payment details:", details);

              try {
                const response = await savePaymentData({
                  orderID: data.orderID,
                  payerID: data.payerID,
                  paymentDetails: details,
                  amount,
                  currency: "USD",
                });

                console.log("Payment saved to server:", response.data);
              } catch (error) {
                console.error("Error saving payment to server:", error);
              }
            });
          }}
          onError={(err) => {
            console.error("PayPal error:", err);
            setCancelMessage(
              "Payment failed. Please try again or contact support"
            );
          }}
          onCancel={(data) => {
            console.warn("Payment was cancelled by the user", data);
            setCancelMessage("Payment was cancelled by the user.");
          }}
        />
      </PayPalScriptProvider>

      <Snackbar
        open={!!cancelMessage}
        autoHideDuration={5000}
        onClose={() => setCancelMessage("")}
        message={cancelMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      />
    </Box>
  );
};

export default PayPalCheckout;
